import { Link } from 'react-router-dom';
import { CTA, HEADLINE, SUBLINE } from './storyScript';
import { StageView, useHeroEngine, useHeroLayout } from './StoryStage';
import { h1LinePx } from './hero/layout';
import StepRow from './StepRow';
import './connect.css';

/* Hero for the teacher landing (/teachers-preview). White page, two-tone
   headline, one pill CTA, then the stage: Buffy acting out the five steps on a
   colorful scene (glow by default, ?frame=tile for the rounded tile).

   Sizes come from one place: hero/layout.js picks the text tier and the stage
   scale for the viewport, so the whole hero fits above the fold at 1440 x 900
   and 1366 x 657 (page spec 2.2 and 2.3). The CSS reads those numbers as
   custom properties. */
export default function ConnectHero() {
  const geo = useHeroLayout();
  const engine = useHeroEngine();
  const tt = geo.text;
  const vars = {
    '--hx-nav-gap': `${tt.navGap}px`,
    '--hx-h1': `${tt.h1}px`,
    '--hx-h1-lh': `${h1LinePx(tt)}px`,
    '--hx-h1-track': `${tt.h1Track}em`,
    '--hx-h1-sub': `${tt.h1Sub}px`,
    '--hx-sub': `${tt.sub}px`,
    '--hx-sub-lh': `${tt.subLh}px`,
    '--hx-sub-stage': `${tt.subStage}px`,
    '--hx-cta': `${tt.cta}px`,
    '--hx-cta-gap': `${tt.ctaGap}px`,
  };
  return (
    <section className="cs-hero" aria-labelledby="cs-title" style={vars} data-tier={geo.tier} data-lines={tt.h1Lines}>
      <h1 id="cs-title" className="cs-title">
        <span className="cs-title-lead">{HEADLINE.lead}</span>
        {' '}
        <span className="cs-title-muted">{HEADLINE.tail}</span>
      </h1>
      <p className="cs-sub">{SUBLINE}</p>
      <div className="cs-stage-wrap" id="cs-stage">
        <StageView
          geo={geo}
          frame={engine.frame}
          source={engine.source}
          paused={engine.paused}
          masking={engine.masking}
          stageRef={engine.stageRef}
        >
          <StepRow engine={engine} geo={geo} />
        </StageView>
      </div>
      {/* owner: the CTA sits underneath the stage */}
      <Link to={CTA.to} className="cs-cta">{CTA.label}</Link>
    </section>
  );
}
